import React, { memo, useRef, useEffect } from 'react';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import { isEqual } from 'lodash';

const defaultProps = {
    height: null,
    value: '',
    disabled: false,
    onReady: () => { },
    onChange: () => { },
    onBlur: () => { },
    onFocus: () => { },
};

class CustomUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }

    upload() {
        return this.loader.file
            .then(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        resolve({ default: reader.result });
                    };
                    reader.onerror = error => {
                        reject(error);
                    };
                    reader.readAsDataURL(file);
                });
            });
    }
}

const CustomCKEditor = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };
    const toolbarContainerRef = useRef(null);

    useEffect(() => {
        return () => {
            if (toolbarContainerRef.current) {
                toolbarContainerRef.current.innerHTML = '';
            }
        };
    }, []);

    return (
        <div>
            <div ref={toolbarContainerRef}></div>
            <CKEditor
                editor={DecoupledEditor}
                data={props.value}
                onReady={(editor) => {
                    if (props.height) {
                        editor.ui.view.editable.element.style.minHeight = `${props.height}px`;
                    }
                    if (props.disabled) {
                        editor.isReadOnly = true;
                    }
                    if (toolbarContainerRef.current) {
                        toolbarContainerRef.current.appendChild(editor.ui.view.toolbar.element);
                    }
                    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                        return new CustomUploadAdapter(loader);
                    };
                    editor.editing.view.change(writer => {
                        writer.setStyle('border', '1px solid var(--ck-color-base-border)', editor.editing.view.document.getRoot());
                    });
                    props.onReady(editor);
                }}
                onChange={(event, editor) => {
                    props.onChange(editor.getData(), editor);
                }}
                onBlur={(event, editor) => {
                    editor.editing.view.change(writer => {
                        writer.setStyle('border', '1px solid var(--ck-color-base-border)', editor.editing.view.document.getRoot());
                    });
                    props.onBlur(editor);
                }}
                onFocus={(event, editor) => {
                    props.onFocus(editor);
                }}
            />
        </div>
    );
}

export default memo(CustomCKEditor, isEqual);
